module.exports = __webpack_public_path__ + "img/tick.45ae5067.png";